module.exports = "mutation UpdateProductComment($comment:UpdateProductCommentInput!){updateComment:updateProductComment(comment:$comment){success}}"